import { loc } from '../data/cards'
import { GOALS } from '../../../shared/taxonomy.ts'
import { haptic } from '../lib/telegram'
import { useSirr } from '../store'

/**
 * Тема ближайшего чтения.
 *
 * Отдельным шагом перед раскладом её не ставим: лишний экран между «хочу
 * погадать» и картами человек проходит не задумываясь, и выбор превращается
 * в формальность. Полоса чипов лежит там, где чтение начинается, — на главной
 * и на экранах ввода, — и её можно просто пролистать мимо.
 *
 * Повторный тап по выбранной теме снимает её: «ни о чём конкретно» —
 * законный ответ, и другого способа к нему вернуться нет.
 */
export function ThemeChips({ compact = false }: { compact?: boolean }) {
  const { profile, lang, t, update } = useSirr()

  return (
    <div className="themechips">
      <span className="themechips__label">{t('focus')}</span>
      {GOALS.map((g) => {
        const active = profile.theme === g.id
        return (
          <button
            key={g.id}
            type="button"
            className="themechips__chip"
            aria-pressed={active}
            onClick={() => {
              haptic.select()
              update({ theme: active ? null : g.id })
            }}
          >
            <span className="themechips__sym">{g.sym}</span>
            {loc(g, lang)}
          </button>
        )
      })}
      {!compact && !profile.theme && <span className="themechips__hint">{t('focusHint')}</span>}
    </div>
  )
}
